import { NpoPlayerEvent } from '../../../types/events';
export function handleStartOffset(playerContext, offset) {
    const { player } = playerContext;
    if (offset == undefined || playerContext.player.isLive()) {
        if (playerContext.player.isLive()) {
            console.warn('handleStartOffset was called but the player is playing live content.');
        }
        return;
    }
    const seek = () => {
        player.off(NpoPlayerEvent.SourceLoaded, seek);
        player.off(NpoPlayerEvent.AdBreakFinished, seek);
        player.off(NpoPlayerEvent.AdError, seek);
        player.seek(offset);
    };
    player.on(NpoPlayerEvent.SourceLoaded, seek);
    player.on(NpoPlayerEvent.AdBreakFinished, seek);
    player.on(NpoPlayerEvent.AdError, seek);
}
export function shiftToProgramStart(playerContext, timestamp) {
    const { player } = playerContext;
    if (timestamp == undefined || !player.isLive()) {
        if (!player.isLive()) {
            console.warn('shiftToProgramStart was called but the player is playing VOD content.');
        }
        return;
    }
    player.timeShift(timestamp);
}
export function handleLiveOffsetLogic(playerContext, options) {
    const { player, npoplayer } = playerContext;
    if (npoplayer.uiComponents.watchFromStartButton == undefined)
        return;
    if (options?.liveProgramTime == undefined) {
        npoplayer.uiComponents.watchFromStartButton.hide();
        return;
    }
    npoplayer.streamOptions.liveProgramTime = options.liveProgramTime;
    if (player.isLive() && options.liveProgramTime > 0) {
        npoplayer.uiComponents.watchFromStartButton.show();
    }
    else {
        npoplayer.uiComponents.watchFromStartButton.hide();
    }
    if (options.liveOffset !== null && options.liveOffset !== false && options.liveProgramTime > 0) {
        npoplayer.uiComponents.watchFromStartButton.hide();
        shiftToProgramStart(playerContext, options.liveProgramTime);
    }
}
